import React from 'react'
import { Grid, Box } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useCreateLoadFormContext } from 'apps/fleet-planner/context'
import { ControlledAttachments } from '../form-components/ControlledAttachments'
import { SectionHeaderText } from './SectionHeaderText'

interface ISectionAttachmentsProps {
  onSuccess: (message: string) => void
}

export const SectionAttachments: React.FC<ISectionAttachmentsProps> = ({ onSuccess }) => {
  const { control } = useCreateLoadFormContext()
  const { isMobile } = useBreakpointContext()

  return (
    <Box pb={isMobile ? 3 : 40}>
      <Grid id='section-attachments' container spacing={3}>
        <Grid item xs={12} md={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SectionHeaderText>Attachments</SectionHeaderText>
            </Grid>
            <Grid item xs={12}>
              <ControlledAttachments name='attachments' control={control} onSuccess={onSuccess} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
